import React, {useState, useEffect} from 'react';
import {CountdownTimerProps, TimeRemaining} from './countdown-timer.types';

export const CountdownTimer = (props: CountdownTimerProps) => {
  const {expirationDate, onExpired} = props;

  const calculateTimeRemaining = (): TimeRemaining => {
    const now = new Date().getTime();
    const expiration = new Date(expirationDate).getTime();
    const difference = expiration - now;

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isExpired: true,
      };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return {
      days,
      hours,
      minutes,
      seconds,
      isExpired: false,
    };
  };

  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining>(
    calculateTimeRemaining(),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeRemaining = calculateTimeRemaining();
      setTimeRemaining(newTimeRemaining);

      if (newTimeRemaining.isExpired && onExpired) {
        onExpired();
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [expirationDate, onExpired]);

  if (timeRemaining.isExpired) {
    return <span style={{color: '#ff4d4f', fontWeight: 'bold'}}>Expired</span>;
  }

  const formatNumber = (num: number) => String(num).padStart(2, '0');

  return (
    <span style={{fontFamily: 'monospace', fontSize: '14px'}}>
      {timeRemaining.days > 0 && (
        <span>
          <strong>{timeRemaining.days}</strong>d{' '}
        </span>
      )}
      <strong>{formatNumber(timeRemaining.hours)}</strong>h{' '}
      <strong>{formatNumber(timeRemaining.minutes)}</strong>m{' '}
      <strong>{formatNumber(timeRemaining.seconds)}</strong>s
    </span>
  );
};
